/*
  Collection tabs (sections/collection-tabs.liquid): standard ARIA tabs.
  Panels are server-rendered; this only toggles which one is visible.
*/
if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (this.tabs.length < 2) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };

      this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.select(i), opts));
      this.querySelector('[role="tablist"]').addEventListener('keydown', (e) => {
        const current = this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
        const keys = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: this.tabs.length - 1 };
        if (!(e.key in keys)) return;
        e.preventDefault();
        const next = (keys[e.key] + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      }, opts);

      // Theme editor: selecting a tab block shows its panel.
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.tabs.indexOf(e.target);
        if (i !== -1) this.select(i);
      }, opts);
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !active;
      });
      // Keep the chosen pill visible when the row scrolls on mobile.
      this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
